// <s-gallery-thumbs> — thumbnail rail that drives an <s-slideshow> by id and mirrors its active slide.
class GalleryThumbs extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    const slideshow = document.getElementById(this.dataset.slideshow);
    if (!slideshow) return;

    this.addEventListener('command', (event) => {
      if (event.command !== '--select') return;
      const index = Number(event.source?.dataset.index);
      if (Number.isNaN(index)) return;
      slideshow.select?.(index);
    }, { signal });

    slideshow.addEventListener('slideshow:change', (event) => {
      const active = event.detail?.index;
      for (const button of this.querySelectorAll('[data-index]')) {
        const isActive = Number(button.dataset.index) === active;
        if (isActive) {
          button.setAttribute('aria-current', 'true');
          this.#reveal(button);
        } else {
          button.removeAttribute('aria-current');
        }
      }
    }, { signal });
  }

  // Scroll only the rail, never the page, so the active thumb stays visible on narrow screens.
  #reveal(button) {
    const rail = button.closest('ul');
    if (!rail) return;
    const start = button.offsetLeft - rail.offsetLeft;
    const end = start + button.offsetWidth;
    if (start < rail.scrollLeft) rail.scrollLeft = start;
    else if (end > rail.scrollLeft + rail.clientWidth) rail.scrollLeft = end - rail.clientWidth;
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }
}

if (!customElements.get('s-gallery-thumbs')) {
  customElements.define('s-gallery-thumbs', GalleryThumbs);
}
